import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  height: 100%;

  img {
    height: 80%;
    width: auto;
  }
`;

export const HeaderItemLabel = styled.div`
  margin: 0;
  font-size: ${({ theme }) => theme.paragraph}px;
  font-family: ${({ theme }) => theme.primaryFontLight};
  color: ${({ theme }) => theme.white};
  padding-left: 10px;
  text-align: left;
  margin-top: 13px;
  span {
    font-size: ${({ theme }) => theme.h5}px;
    font-family: ${({ theme }) => theme.primaryFontMedium};
  }
  &:first-child {
    margin: 0px;
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
